import AuthService from '../Services/AuthService';
import LocalStorageService from '../Services/LocalStorageService';
import {
  ASSET_MODEL,
  BILLING,
  CORE,
  DASHBOARD,
  GEOFENCE,
  MAINTENANCE,
  ORGANIZATION,
  PROVISION,
  REMOTE,
  REPORT,
  USER,
  USER_PERMISSION,
} from '../Constants/RBAC';

export const PERMISSION_ORDERING_MAP = new Map([
  [CORE, 0],
  [ASSET_MODEL, 1],
  [DASHBOARD, 2],
  [GEOFENCE, 3],
  [MAINTENANCE, 4],
  [ORGANIZATION, 5],
  [PROVISION, 6],
  [REMOTE, 7],
  [REPORT, 8],
  [USER, 9],
  [USER_PERMISSION, 10],
  [BILLING, 11],
]);

const auth = new AuthService();
const ls = new LocalStorageService();

/**
 * TODO: #getPermissionsFromLocalStorage should be replaced
 * by an implementation of SSE that updates the session
 * permissions whenever an organizatin is created/moved
 */
export function getPermissionsFromLocalStorage(orgID) {
  const rootOrgID = auth.getUserRootOrgID();
  const permissions = ls.getObjectByKey('permissions');
  if (!permissions) return {};
  if (orgID in permissions) return permissions;

  const rootOrgPerms = permissions[rootOrgID] || '';
  const newOrgAddedPerms = Object.assign({}, permissions, {
    [orgID]: rootOrgPerms,
  });
  ls.setObject('permissions', newOrgAddedPerms);
  return newOrgAddedPerms;
}

export function getPermissionForResource(orgID, resource) {
  const permissions = getPermissionsFromLocalStorage(orgID);

  const resourcePermission =
    permissions?.[orgID]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)];
  return Number.parseInt(resourcePermission, 10);
}

export function hasReadAccessToResource(orgID, resource) {
  const permissions = getPermissionsFromLocalStorage(orgID);

  const resourcePermission =
    permissions?.[orgID]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)];
  return !!Number.parseInt(resourcePermission, 10);
}

export function hasWriteAccessToResource(orgID, resource) {
  const permissions = getPermissionsFromLocalStorage(orgID);

  const resourcePermission =
    permissions?.[orgID]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)];
  return Number.parseInt(resourcePermission, 10) >= 2;
}

export function hasManageAccessToResource(orgID, resource) {
  const permissions = getPermissionsFromLocalStorage(orgID);

  const resourcePermission =
    permissions?.[orgID]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)];
  return Number.parseInt(resourcePermission, 10) >= 3;
}

export function hasReadAccessToEcosystem(orgID, resource, orgsMap = {}) {
  const permissions = getPermissionsFromLocalStorage(orgID);

  const targetOrgResourcePermission =
    permissions?.[orgID]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)];
  if (!Number.parseInt(targetOrgResourcePermission, 10)) return false;

  const ecosystemOrgIDs = Object.entries(orgsMap).reduce(
    (acc, [id, { path }]) =>
      path.includes(orgID) && id !== orgID ? acc.concat(id) : acc,
    []
  );
  if (!ecosystemOrgIDs?.length) return false;

  return ecosystemOrgIDs.some(
    (id) =>
      !!Number.parseInt(
        permissions?.[id]?.split(',')?.[PERMISSION_ORDERING_MAP.get(resource)],
        10
      )
  );
}
